import jQuery from 'jquery';

const VIMEO_READY_TIMEOUT_MS = 10000;

function whenVimeoReady( callback ) {
	if ( window.Vimeo ) {
		callback();
		return;
	}

	const startedAt = Date.now();
	const timer     = window.setInterval( () => {
		if ( window.Vimeo ) {
			window.clearInterval( timer );
			callback();
			return;
		}

		if ( Date.now() - startedAt >= VIMEO_READY_TIMEOUT_MS ) {
			window.clearInterval( timer );
		}
	}, 50 );
}

function setButtonIconState( $button, showSelector, hideSelector ) {
	$button.find( showSelector ).removeAttr( 'hidden' );
	$button.find( hideSelector ).attr( 'hidden', 'hidden' );
}

function initVimeoCard( $root ) {
	if ( $root.data( 'vimeoInit' ) ) {
		return;
	}

	const iframe = $root.find( 'iframe' ).get( 0 );
	if ( ! iframe || ! /vimeo\.com/i.test( iframe.src || '' ) ) {
		return;
	}

	const $playBtn = $root.find( '[data-vimeo-action="play-pause"]' );
	const $muteBtn = $root.find( '[data-vimeo-action="mute"]' );

	if ( ! $playBtn.length || ! $muteBtn.length ) {
		return;
	}

	const player = new window.Vimeo.Player( iframe );

	const syncPlayState = ( paused ) => {
		if ( paused ) {
			setButtonIconState( $playBtn, '.home-start__card__video-icon--play', '.home-start__card__video-icon--pause' );
			$playBtn.attr( 'aria-label', $playBtn.data( 'labelPlay' ) || 'Abspielen' );
		} else {
			setButtonIconState( $playBtn, '.home-start__card__video-icon--pause', '.home-start__card__video-icon--play' );
			$playBtn.attr( 'aria-label', $playBtn.data( 'labelPause' ) || 'Pause' );
		}
	};

	const syncMuteState = ( muted ) => {
		if ( muted ) {
			setButtonIconState( $muteBtn, '.home-start__card__video-icon--mute', '.home-start__card__video-icon--volume' );
			$muteBtn.attr( 'aria-label', $muteBtn.data( 'labelUnmute' ) || 'Ton einschalten' );
		} else {
			setButtonIconState( $muteBtn, '.home-start__card__video-icon--volume', '.home-start__card__video-icon--mute' );
			$muteBtn.attr( 'aria-label', $muteBtn.data( 'labelMute' ) || 'Stummschalten' );
		}
	};

	player
		.getPaused()
		.then( syncPlayState )
		.catch( () => {} );
	player
		.getMuted()
		.then( syncMuteState )
		.catch( () => {} );

	player.on( 'play', () => syncPlayState( false ) );
	player.on( 'pause', () => syncPlayState( true ) );
	player.on( 'volumechange', ( data ) => {
		syncMuteState( Boolean( data.muted ) || 0 === data.volume );
	} );

	$playBtn.on( 'click', ( event ) => {
		event.preventDefault();
		event.stopPropagation();

		player.getPaused().then( ( paused ) => {
			if ( paused ) {
				return player.play();
			}
			return player.pause();
		} );
	} );

	$muteBtn.on( 'click', ( event ) => {
		event.preventDefault();
		event.stopPropagation();

		player.getMuted().then( ( muted ) => player.setMuted( ! muted ) );
	} );

	$root.data( 'vimeoInit', true );
}

function initVimeoCards( context ) {
	const $scope = context ? $( context ) : $( document );

	$scope.find( '.home-start__card__video' ).each( function () {
		initVimeoCard( $( this ) );
	} );
}

function bootVimeoCards() {
	if ( ! document.querySelector( '.home-start__card__video iframe' ) ) {
		return;
	}

	whenVimeoReady( () => {
		initVimeoCards();
	} );
}

$( document ).ready( bootVimeoCards );

$( document ).on( 'home-start:viewchange', '.home-start', function () {
	whenVimeoReady( () => {
		initVimeoCards( this );
	} );
} );
